const getters = {
  contacts: (state) => state.contacts,
  contacts_page: (state) => state.contacts_page,
  contacts_pages_total: (state) => state.contacts_pages_total,
}

export default getters
